import { graphQuery } from "shared/lib/graphql"
import { LiveChannelsQuery } from "./queries"

export const LoadLiveChannels = module_name => {
  return graphQuery(LiveChannelsQuery, {
    serviceModuleName: module_name,
  })
}
